import { Checkbox } from 'vant'
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog'
export default {
    name: 'couponInfo',
    data () {
        return {}
    },
    components: {
        appGuideDialog,
        Checkbox
    },
    props: {
        coupon: {
            type: Object,
            default: {}
        },
        source: {
            type: Number,
            default: 1
        },
        checked: {
            type: Boolean,
            default: true
        },
        sstoreId: {
            type: String,
            default: ''
        }
    },
    created () { },
    activated () { },
    mounted () { },
    methods: {
        clickToShowTip (coupon) {
            this.$emit('showTips', coupon)
        },
        clickGetCoupon (coupon) {
            this.$emit('clickGetCoupon', coupon)
        },
        checkboxChange (coupon) {
            this.$emit('checkboxChange', coupon)
        }
    },
}
